// extracted by mini-css-extract-plugin
export default {"wrapper":"kFkYm3xEMD3A0EGZhR2qGQ=="};